import { render, staticRenderFns } from "./CanvasBlockLabel.vue?vue&type=template&id=20bfc982&scoped=true&"
import script from "./CanvasBlockLabel.vue?vue&type=script&lang=js&"
export * from "./CanvasBlockLabel.vue?vue&type=script&lang=js&"
import style0 from "./CanvasBlockLabel.vue?vue&type=style&index=0&id=20bfc982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bfc982",
  null
  
)

export default component.exports